import React from "react";

// Components imports
import InputField from "../../../common/InputField";

// Scss imports
import css from "./Address.module.scss";
interface AddressProps {
  place: string;
  street: string;
  buildingNumber: number;
  letter: string;
  floor: number;
  apartmentNumber: number;
  municipality: string;
  zipCode: number;
  handleChange: Function;
  errorText: string;
  placeError: string;
  municipalityError: string;
  zipCodeError: string;
  streetError: string;
  buildingNumberError;
}

const Address: React.FC<AddressProps> = ({
  place,
  street,
  buildingNumber,
  letter,
  floor,
  apartmentNumber,
  municipality,
  zipCode,
  handleChange,
  errorText,
  placeError,
  municipalityError,
  zipCodeError,
  streetError,
  buildingNumberError
}) => {
  return (
    <div className={css.container}>
      <div className={css.inputFieldWrapper}>
        <InputField
          label="Место"
          name="place"
          id="place"
          type="text"
          placeholder="Београд"
          value={place}
          handleChange={handleChange}
          handleOnFocus={(e: any) => (e.target.placeholder = "")}
          handleOnBlur={(e: any) => (e.target.placeholder = "Београд")}
          errorText={placeError}
        />
      </div>
      <div className={css.inputFieldWrapper}>
        <InputField
          label="Општина"
          name="municipality"
          id="municipality"
          type="text"
          placeholder="Савски Венац"
          value={municipality}
          handleChange={handleChange}
          handleOnFocus={(e: any) => (e.target.placeholder = "")}
          handleOnBlur={(e: any) => (e.target.placeholder = "Савски Венац")}
          errorText={municipalityError}
        />
      </div>
      <div className={css.inputFieldWrapper}>
        <InputField
          label="Поштански број"
          name="zipCode"
          id="zipCode"
          type="text"
          placeholder="11000"
          value={zipCode}
          handleChange={handleChange}
          handleOnFocus={(e: any) => (e.target.placeholder = "")}
          handleOnBlur={(e: any) => (e.target.placeholder = "11000")}
          errorText={zipCodeError}
        />
      </div>
      <div className={css.inputFieldWrapper}>
        <InputField
          label="Улица"
          name="street"
          id="street"
          type="text"
          placeholder="Балканска"
          value={street}
          handleChange={handleChange}
          handleOnFocus={(e: any) => (e.target.placeholder = "")}
          handleOnBlur={(e: any) => (e.target.placeholder = "Балканска")}
          errorText={streetError}
        />
      </div>
      <div className={css.inputFieldWrapper}>
        <InputField
          label="Број"
          name="buildingNumber"
          id="buildingNumber"
          type="text"
          placeholder="54"
          value={buildingNumber}
          handleChange={handleChange}
          handleOnFocus={(e: any) => (e.target.placeholder = "")}
          handleOnBlur={(e: any) => (e.target.placeholder = "54")}
          errorText={buildingNumberError}
        />
      </div>
      <div className={css.inputFieldWrapper}>
        <InputField
          label="Слово"
          name="letter"
          id="letter"
          type="text"
          placeholder="А"
          value={letter}
          handleChange={handleChange}
          handleOnFocus={(e: any) => (e.target.placeholder = "")}
          handleOnBlur={(e: any) => (e.target.placeholder = "А")}
        />
      </div>
      <div className={css.inputFieldWrapper}>
        <InputField
          label="Спрат"
          name="floor"
          id="floor"
          type="text"
          placeholder="5"
          value={floor}
          handleChange={handleChange}
          handleOnFocus={(e: any) => (e.target.placeholder = "")}
          handleOnBlur={(e: any) => (e.target.placeholder = "5")}
        />
      </div>
      <div className={css.inputFieldWrapper}>
        <InputField
          label="Број стана"
          name="apartmentNumber"
          id="apartmentNumber"
          type="text"
          placeholder="54"
          value={apartmentNumber}
          handleChange={handleChange}
          handleOnFocus={(e: any) => (e.target.placeholder = "")}
          handleOnBlur={(e: any) => (e.target.placeholder = "54")}
        />
      </div>
    </div>
  );
};

export default Address;
